import { render, staticRenderFns } from "./Fiscal.vue?vue&type=template&id=3c878be4&"
import script from "./Fiscal.vue?vue&type=script&lang=js&"
export * from "./Fiscal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports